import React from "react"
//import I18n from "i18n-js/index.js.erb"
import clsx from "clsx"
import RoleBuilderErrors from "../RoleBuilderErrors"

export default class RoleBuilderGeneral extends React.Component{

  constructor(props) {
    super(props);
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="general">

        {this.renderErrors()}

        {/* {this.renderPrintButton()} */}

        {this.props.owner && !this.props.modifying_self ? <div className="alert alert-warning text-center"><strong>{I18n.t('the_owner_role_cannot_be_modified')}</strong></div> : null}

        <div className="row">
          <div className="col-md-12">
            {this.renderGeneralForm()}
          </div>
        </div>

      </div>
    );
  }

  renderErrors() {
    var errors = RoleBuilderErrors.general(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderGeneralForm() {
    return (<div>
      <div className="row">

        <div className="col-sm-6">
          <div className="form-group">
            <label>{`${I18n.t('name')}*`}</label>
            {this.props.read_only || (this.props.owner && !this.props.modifying_self) ? <div>{this.props.role_name}</div> : <input type="text" autoComplete="off" name="Role[name]" className={this.renderFieldClasses('name')} value={this.props.role_name || ''} onChange={this.props.onChangeName} />}
          </div>
          {this.renderFieldErrors('name')}
        </div>
      </div>

    </div>);
  }

  renderFieldErrors(field) {
    //console.log('renderFieldErrors', field, this.props.errors, this.props.errors[field]);
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field, classname) {

    var classname = classname || 'form-control';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

  // parseInputName(name) {
  //   return name.match(/Role\[(.*)\]/)[1];
  // }

};
